// extracted by mini-css-extract-plugin
export default {"existingTimeOffContainer":"ExistingTimeOffDetails_existingTimeOffContainer__PFfC4"};